<template>
  <div v-if="transcriptions.length">
    <div class="responsive-cards-wrapper">
      <TranscriptionCard
        v-for="transcription in transcriptions"
        :key="transcription._id"
        v-focus
        :transcription="transcription"
      />
    </div>
    <!-- Pagination -->
    <PaginationElement
      v-if="itemCount"
      @changeCurrentPage="page = $event"
      :current-page="page"
      :total-items="itemCount"
      :items-limit="pageSize"
    />
  </div>
  <NoData v-else />
</template>
<script setup lang="ts">
import NoData from "../../reusable/atoms/NoData.vue";
import PaginationElement from "../../reusable/atoms/PaginationElement.vue";
import TranscriptionCard from "../molecules/TranscriptionCard.vue";
import { useTranscriptionsStore } from "@/follaw-fr/stores/transcriptions";
import { storeToRefs } from "pinia";

const { page, pageSize, itemCount, transcriptions } = storeToRefs(
  useTranscriptionsStore()
);
</script>
